"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPayment = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsPay_1 = require("../../model/hsPay");
var service_1 = require("../../../library/base/service");
var ProductPayment = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ProductPayment, _super);
    function ProductPayment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '理财产品购买接口';
        _this.code = '105020';
        _this.desc = '理财产品购买接口';
        _this.requestParams = new hsPay_1.ProductPaymentRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ProductPayment;
}(service_1.BaseService));
exports.ProductPayment = ProductPayment;
//# sourceMappingURL=productPayment.js.map